import Phaser from 'phaser';
import { COLORS } from '../main';

export interface MenuStartData {
  seed?: number;
}

export class MenuScene extends Phaser.Scene {
  constructor() {
    super('Menu');
  }

  create(): void {
    const { width, height } = this.scale;

    this.add
      .text(width / 2, height * 0.2, 'DICEYDICE', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '44px',
        fontStyle: 'bold',
        color: '#fbbf24',
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height * 0.28, 'roll · place · climb the pyramid', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '14px',
        color: '#9ca3af',
      })
      .setOrigin(0.5);

    const rules = [
      '• Draw 3 dice each turn from your bag',
      '• Place all 3 on cards (split or together)',
      '• Acquire cards adjacent to your last',
      '• Lowest die stays on each acquired card',
      '• Reach the apex to win',
    ];
    this.add
      .text(width / 2, height * 0.42, rules.join('\n'), {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '14px',
        color: '#e6edf3',
        align: 'left',
        lineSpacing: 8,
      })
      .setOrigin(0.5);

    this.makeButton(width / 2, height * 0.66, 'Start Game', () => {
      const seed = Math.floor(Math.random() * 2 ** 31);
      this.scene.start('Game', { seed } satisfies MenuStartData);
    });

    this.add
      .text(width / 2, height * 0.92, 'tap a card to zoom in', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '12px',
        color: '#6b7280',
      })
      .setOrigin(0.5);
  }

  private makeButton(x: number, y: number, label: string, onClick: () => void): void {
    const w = 180;
    const h = 52;
    const bg = this.add
      .rectangle(x, y, w, h, COLORS.accent)
      .setStrokeStyle(2, COLORS.border)
      .setInteractive({ useHandCursor: true });
    this.add
      .text(x, y, label, {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '20px',
        fontStyle: 'bold',
        color: '#0d1117',
      })
      .setOrigin(0.5);
    bg.on('pointerdown', onClick);
    bg.on('pointerover', () => bg.setScale(1.04));
    bg.on('pointerout', () => bg.setScale(1));
  }
}
